export default function initDownload() {
    document.querySelectorAll(".download").forEach((button) => {
        button.addEventListener("click", async (e) => {
            e.preventDefault();

            const url = button.dataset.url || location.href;
            window.open(url, "_blank");
        });
    });
}
